/**
 * Verse study API client — deterministic verse data, no ML inference.
 */

import type { ScriptureResponse } from '@skjv/common';
import { apiPath } from '@utils/api-base';

/**
 * Fetch verse study data (words, Strong's, Webster's, cross-refs, variants, pericope).
 * No ML inference — purely DB-driven.
 */
export async function fetchVerseStudy(
  reference: string,
  scope?: 'verse' | 'pericope',
): Promise<ScriptureResponse> {
  const response = await fetch(apiPath('v1/verse-study'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(scope ? { reference, scope } : { reference }),
  });

  if (!response.ok) {
    throw new Error(`Verse study API error: ${response.status}`);
  }

  return (await response.json()) as ScriptureResponse;
}
